module.exports = __webpack_public_path__ + "static/media/fast-delivery.a7e9dceb.svg";